import React, { useContext, useEffect, useState } from "react";
import DropDown from "../../../components/DropDown";
import TextInput from "../../../components/TextInput";

const DBFilterBar = ({ datas, setFilteredDatas }) => {
  const [sort, setSort] = useState();
  const [searchText, setSearchText] = useState("");

  const searchHandler = () => {
    if (searchText) {
      return datas.filter((survey) => {
        const surveyData = `${survey.name.toUpperCase()}`;
        const textData = searchText.toUpperCase();

        // Check main client
        if (surveyData.indexOf(textData) > -1) {
          return true;
        }

        return false;
      });
    } else {
      return datas;
    }
  };

  const onChange = () => {
    let tmpDatas = [...searchHandler()] ?? [];

    if (sort) {
      tmpDatas = tmpDatas.sort((a, b) => {
        if (sort == "Oldest to Newest") {
          if (a.timestamp.toDate() > b.timestamp.toDate()) return 1;
          else return -1;
        }
        if (sort == "Newest to Oldest") {
          if (a.timestamp.toDate() < b.timestamp.toDate()) return 1;
          else return -1;
        }
      });
    }

    setFilteredDatas(tmpDatas);
  };

  useEffect(() => {
    onChange();
  }, [sort, searchText]);

  return (
    <div className="mt-3 flex items-start gap-x-4 ">
      <TextInput
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search here.."
        containerStyle="flex-1 mr-5"
      />
      <DropDown
      
        placeHolder={"Sort"}
        options={["Oldest to Newest", "Newest to Oldest"].map((e) => ({
          value: e,
          label: e
        }))}
        className=" mb-5 "
        onChange={(e) => setSort(e[0].value)}
      />
    </div>
  );
};

export default DBFilterBar;
